module.exports = __webpack_public_path__ + "static/media/400167_02.4e5bc055.png";